import { TValidationState, color } from '../utils';

type TFormStateColorStyles = {
  formStateColor: string | undefined;
};

const formStateColors = {
  error: color.red02,
};

export const getFormStateColor = (state: TValidationState): TFormStateColorStyles => {
  return { formStateColor: formStateColors[state] };
};
